<div class="w-full h-full inline-block align-middle">
    <div class="flex justify-center w-full md:mt-11 pb-8">
        <img src="assets/icons/Icons/Group.png" alt="adumoeft logo">
    </div>
    <div class="flex justify-center pt-4 pb-6">
        <h3 class="text-center"><b>Please wait while you are redirected to Adumoeft</b></h3>
    </div>
    <div class="flex justify-center pt-4 pb-8" *ngIf="loading">
        <mat-spinner></mat-spinner>
    </div>
    <p class="subtext flex justify-center">Redirecting in <countdown class="text-lg ml-4" [config]="config"></countdown></p>
</div>
